module.exports = {"forgot_pass":"¿Olvidó su contraseña?","return":"Volver","find_availability":"Click para encontrar disponibilidad"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/es/links.json
// module id = 728
// module chunks = 18